import APIModel from "../../APIModel";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../store/state/state";
import { useCallback, useEffect, useState } from "react";
import CustomerRow from "../../component/CustomerRow";
import "./CostumerList.scss";
import {
  Link,
  Navigate,
  redirect,
  useLoaderData,
  useSearchParams,
} from "react-router-dom";
import store from "../../store/store";
import ReactPaginate from "react-paginate";
import debounce from "lodash.debounce";
import errorExceptionSwitch from "../../component/errorExceptionSwitch";

export default function CostumerList() {
  const consumer = useLoaderData();
  let [searchParams, setSearchParams] = useSearchParams();
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [queryInput, setQueryInput] = useState(searchParams.get("q"));

  const onChangeInput = (e) => {
    setSearchParams((searchParams) => {
      searchParams.set("q", e.target.value);
      return searchParams;
    });
    setQueryInput(e.target.value);
  };

  useEffect(() => {
    APIModel.getConsumers(
      token,
      searchParams.get("q"),
      searchParams.get("page"),
      searchParams.get("sort")
    ).then((res) => {
      const url = errorExceptionSwitch(res.status);
      console.log(url);

      if (!url.success) {
        dispatch(setToken(""));
        console.log("test");
        return redirect("/login");
      } else {
        setData(res.body);
      }
    });
  }, [searchParams]);
  return (
    <div className="costumer-list">
      <div className="costumer-list__search">
        <input
          placeholder="search..."
          className="costumer-list__input"
          value={queryInput}
          onChange={onChangeInput}
        />
        <Link to="costumer/create">create</Link>
      </div>
      <div className="customer-row first-row">
        <h2 className="customer-row__field">first name</h2>
        <h2 className="customer-row__field">last name</h2>
        <h2 className="customer-row__field">key</h2>
        <h2 className="customer-row__field">expressedIn</h2>
        <h2 className="customer-row__field">create</h2>
        <h2 className="customer-row__field">comment</h2>
      </div>
      {data.content?.map((item) => (
        <Link
          key={item.id}
          to={"/costumer/get/" + item.id}
          className="customer-row__link"
        >
          <CustomerRow customer={item} />
        </Link>
      ))}
      <ReactPaginate
        className="navigation"
        breakLabel="..."
        nextLabel=">"
        previousLabel="<"
        pageRangeDisplayed={10}
        pageCount={10}
        onPageChange={(e) => {
          setSearchParams((searchParams) => {
            searchParams.set("page", e.selected);
            return searchParams;
          });
        }}
      />
    </div>
  );
}
